import * as _ from "lodash";

import { HELDUP_HOURS } from "@/constants/dashboard";
import { parseAdaPath } from "@/utils/util";

// calculate heldUp and processing files
export const updateDashboard = (dashboard) => {
  const newDashboard = _.cloneDeep(dashboard);
  const expiryDate = dashboard.ignore_held_up;
  let filesHeldUp = 0;
  let filesProcessing = 0;

  for (const file of newDashboard.files) {
    const fileIsConfirmed = file.confirmed;
    const fileIsExpired = parseAdaPath(file.ada_file).process_date < expiryDate;
    file.finalDestination = getFinalDestination(file);
    const atFinalDestination = !!file[file.finalDestination];

    if (fileIsExpired || atFinalDestination) {
      // file is either expired or processed
      file.held_up = false;
      file.processing = false;
    } else if (
      // file is held up
      !fileIsExpired &&
      fileIsConfirmed &&
      !atFinalDestination &&
      isStuckBeforeFinalDestination(file)
    ) {
      file.held_up = true;
      file.processing = false;
      filesHeldUp++;
    } else if (fileIsConfirmed) {
      // file is processing
      file.processing = true;
      file.held_up = false;
      filesProcessing++;
    } else {
      file.processing = false;
    }
  }

  newDashboard.held_up = filesHeldUp;
  newDashboard.processing = filesProcessing;
  return newDashboard;
};

export const filterRows = (
  rows,
  searchTerm,
  filter,
  startDate,
  endDate,
  local,
  summaryResponse
) => {
  return rows.filter((row) => {
    let fileMatch;

    if (local) {
      fileMatch = row.local === local.id;
    } else {
      const fileNameMatch = row.fileName
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
      const localNameMatch = row.local_name
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
      fileMatch = searchTerm.length === 0 || fileNameMatch || localNameMatch;
    }

    const isWithinDateRange = () => {
      const fileDate = new Date(row.processDate);
      const fileDateString = fileDate?.toISOString().split("T")[0];
      const startDateString = isValidDate(startDate)
        ? startDate.toISOString().split("T")[0]
        : undefined;
      const endDateString = isValidDate(endDate)
        ? endDate.toISOString().split("T")[0]
        : undefined;

      if (startDateString && endDateString) {
        return (
          fileDateString >= startDateString && fileDateString <= endDateString
        );
      } else {
        return true;
      }
    };

    const isOutOfDate = summaryResponse?.out_of_date?.includes(row.local);

    switch (filter) {
      case "All":
        return fileMatch && isWithinDateRange();
      case "Processing":
        return row.processing && fileMatch && isWithinDateRange();
      case "Held Up":
        return row.held_up && fileMatch && isWithinDateRange();
      case "Out of Date":
        return isOutOfDate && fileMatch && isWithinDateRange();
      default:
        return fileMatch && isWithinDateRange();
    }
  });
};

const isValidDate = (date) => {
  if (date) {
    return date?.toString() != "Invalid Date";
  } else {
    return false;
  }
};

const greaterThanHeldUpHours = (time) => {
  const parsedTime = Date.parse(time),
    now = Date.now(),
    differenceMilliseconds = now - parsedTime,
    differenceSeconds = differenceMilliseconds / 1000,
    differenceMinutes = differenceSeconds / 60,
    differenceHours = Math.floor(differenceMinutes / 60);
  return differenceHours > HELDUP_HOURS;
};

const getFinalDestination = (file) => {
  const finalDestination =
    file.catalist === "excluded" && file.VAN === "excluded"
      ? "confirmed"
      : file.catalist !== "excluded" && file.VAN === "excluded"
        ? "catalist"
        : "VAN";
  return finalDestination;
};

const isStuckBeforeFinalDestination = (file) => {
  if (file.finalDestination === "confirmed") {
    // never held up
    return false;
  }
  if (file.finalDestination === "catalist") {
    return greaterThanHeldUpHours(file.confirmed);
  }
  if (file.finalDestination === "VAN") {
    return (
      greaterThanHeldUpHours(file.confirmed) ||
      greaterThanHeldUpHours(file.catalist)
    );
  }
};

export const getLocalsFromDashboardFiles = (files) => {
  if (!files) {
    return;
  }
  let uniqueLocals = {};
  files.forEach((file) => {
    const localId = parseAdaPath(file.ada_file).affiliate;
    if (!(localId in uniqueLocals)) {
      uniqueLocals[localId] = `${localId} - ${file.local_name}`;
    }
  });
  uniqueLocals = Object.entries(uniqueLocals).map(([id, display_name]) => ({
    id,
    display_name,
  }));
  return uniqueLocals;
};
